module.exports = __webpack_public_path__ + "img/Character_Sangonomiya_Kokomi_Thumb.7f3e02a9.png";